// src/pages/Homepage.jsx
import React, { useState } from "react";
import "./Homepage.css";
import api from "../utils/api";

export default function Homepage() {
  const [formData, setFormData] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/homepage/submit", formData);
      setSubmitted(true);
    } catch (err) {
      alert("Error submitting form");
    }
  };

  if (submitted) {
    return (
      <div className="thank-you">
        <h1>✅ Thanks for your feedback!</h1>
        <p>We’ll keep you posted as we launch near you 🚀</p>
      </div>
    );
  }

  return (
    <div className="homepage-wrapper">
      {/* Header with links */}
      <header className="homepage-header">
        <a href="/seller/start" className="seller">👩‍🍳 Register as Seller</a>
        <a href="/driver" className="driver">🚗 Apply as Driver</a>
      </header>

      <div className="form-container">
        <img src="/logo.png" alt="HomeFoodGrab Logo" className="logo" />
        <div className="brand-name">HomeFoodGrab</div>
        <div className="subheading">🚀 Launching Soon Near You - </div>
        <h1>Your Food, Your Choice</h1>
        <p style={{ textAlign: "center" }}>
          Help us shape the future of home food. Take 30 seconds to share your preferences.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-grid">

            {/* Food Preferences */}
            <div className="form-section">
              <label>Food Preferences</label>
              <div className="options">
                <span>Home-cooked meals</span>
                <input type="radio" name="food_pref" value="Home-cooked" required onChange={handleChange} />
                <span>Restaurant food</span>
                <input type="radio" name="food_pref" value="Restaurant" required onChange={handleChange} />
                <span>Both</span>
                <input type="radio" name="food_pref" value="Both" required onChange={handleChange} />
              </div>
            </div>

            {/* Access Preference */}
            <div className="form-section">
              <label>Access Preference</label>
              <div className="options">
                <span>Pickup nearby</span>
                <input type="radio" name="access_pref" value="Pickup" required onChange={handleChange} />
                <span>Delivery</span>
                <input type="radio" name="access_pref" value="Delivery" required onChange={handleChange} />
              </div>
            </div>

            {/* What matters most */}
            <div className="form-section">
              <label>What matters most?</label>
              <div className="options">
                <span>Price (Value)</span>
                <input type="radio" name="priority" value="Value" required onChange={handleChange} />
                <span>Healthy options</span>
                <input type="radio" name="priority" value="Healthy" required onChange={handleChange} />
                <span>Premium quality</span>
                <input type="radio" name="priority" value="Premium" required onChange={handleChange} />
              </div>
            </div>

            {/* Spending */}
            <div className="form-section">
              <label>Spending on lunch/dinner</label>
              <select name="spending" required onChange={handleChange}>
                <option value="">-- Select --</option>
                <option>£3-5</option>
                <option>£6-10</option>
                <option>£11-15</option>
                <option>£16+</option>
              </select>
            </div>

            {/* Value vs Premium */}
            <div className="form-section">
              <label>Would you prefer...</label>
              <select name="meal_pref" required onChange={handleChange}>
                <option value="">-- Select --</option>
                <option>Value Meal (£3.99)</option>
                <option>Premium Meal (£6.99)</option>
              </select>
            </div>

            {/* Eating out */}
            <div className="form-section">
              <label>Food outside home per week</label>
              <select name="food_outside" required onChange={handleChange}>
                <option value="">-- Select --</option>
                <option>1–2 times</option>
                <option>3–5 times</option>
                <option>6+ times</option>
              </select>
            </div>

            {/* Subscription */}
            <div className="form-section">
              <label>Would you like subscription/meal plans?</label>
              <select name="subscription" required onChange={handleChange}>
                <option value="">-- Select --</option>
                <option>Yes</option>
                <option>No</option>
                <option>Maybe</option>
              </select>
            </div>

            {/* Age Group */}
            <div className="form-section">
              <label>Age Group</label>
              <select name="age_group" required onChange={handleChange}>
                <option value="">-- Select --</option>
                <option>18-25</option>
                <option>26-40</option>
                <option>41-60</option>
                <option>60+</option>
              </select>
            </div>

            {/* Personal details */}
            <div className="form-section">
              <label>Your Details</label>
              <input type="text" name="name" placeholder="Full Name" required onChange={handleChange} />
              <input type="email" name="email" placeholder="you@example.com" required onChange={handleChange} />
              <input
                type="text"
                name="postcode"
                placeholder="Postcode (e.g., M1 2AB)"
                required
                pattern="[A-Za-z0-9 ]{5,8}"
                onChange={handleChange}
              />
            </div>
          </div>

          <button type="submit">Count Me In 🚀</button>
        </form>

        <footer>
          © HomeFoodGrab 2025 | <a href="/privacy.html">Privacy Policy</a> |{" "}
          <a href="/terms.html">Terms of Services</a>
        </footer>
      </div>
    </div>
  );
}

